var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteMetroRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "rd76hgoo5b",
    d: "M0 0L23 0 23 23.842 0 23.842z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#54534D",
    d: "M19.472 26H3.528c-.406 0-.735-.322-.735-.72 0-.397.33-.72.735-.72h15.944c.406 0 .735.323.735.72 0 .398-.33.72-.735.72",
    transform: "translate(2.000000, 1.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54534D",
    d: "M18.945 19.932c-.664 0-1.202-.527-1.202-1.177 0-.649.538-1.176 1.202-1.176.663 0 1.202.527 1.202 1.176 0 .65-.539 1.177-1.202 1.177zM5.889 15.766c-1.294 0-2.348-1.03-2.348-2.297l.004-.068.512-5.316c.134-1.37 1.091-2.188 2.56-2.188h9.766c1.469 0 2.426.817 2.56 2.186l.516 5.386c0 1.267-1.054 2.297-2.348 2.297H5.889zm-1.833 4.166c-.664 0-1.203-.527-1.203-1.177 0-.649.539-1.176 1.203-1.176.663 0 1.201.527 1.201 1.176 0 .65-.538 1.177-1.201 1.177zM7.142 2.95h8.716c.407 0 .736.323.736.72 0 .398-.33.72-.736.72H7.142c-.407 0-.736-.322-.736-.72 0-.397.33-.72.736-.72zm15.844 17.193L21.357 4.525l-.007-.052C20.885 1.893 18.602.02 15.924.02L11.497 0 7.079.02C4.398.02 2.115 1.893 1.65 4.473l-.005.026L.013 20.154c-.009.096-.013.195-.013.292 0 1.872 1.555 3.394 3.467 3.394l8.032.002 8.034-.002c1.912 0 3.467-1.522 3.467-3.394 0-.097-.004-.196-.014-.304z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#54534D",
    d: "M16.383 7.337H6.617c-.707 0-1.035.264-1.096.884l-.508 5.277c.016.46.403.829.876.829h11.222c.473 0 .86-.37.876-.83l-.508-5.277c-.06-.619-.389-.883-1.096-.883",
    transform: "translate(2.000000, 1.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteMetroRed);
export default __webpack_public_path__ + "static/media/transporteMetroRed.a907b51c.svg";
export { ForwardRef as ReactComponent };